import { service } from ".";

export default {
  getAll: () => service.get("/paymentPlan"),
  create: (data) => service.post(`/paymentPlan`, data),
  update: (id, data) => service.put(`/paymentPlan/${id}`, data),
  delete: (id) => service.delete(`/paymentPlan/${id}`),
};
